import React from 'react';
import { Button, Input } from 'antd';
import Box from '@mui/material/Box';
import ProductTable from '../components/ProductTable';

import { useAdminControl } from "../store/Store"

const ProductPage = () => {

    const { openDrawer, setSelectedProduct } = useAdminControl();
    

    const handleAddNew = () => {
        setSelectedProduct(null);
        openDrawer('productUpload');
    };

    const handleEdit = (product) => {
        setSelectedProduct(product);
        openDrawer('productUpload');
    };



    return (
        <Box>
            
            <Box sx={{ height: '60px', width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                <Box
                    sx={{
                        height: '100%', width: '100%', maxWidth: '1200px', bgcolor: '#ffff', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px', gap: '10px',
                    }} >

                    <Box sx={{ marginLeft: { xs: '10px', sm: '20px' } }}>
                        <Button type="primary" size="md" onClick={handleAddNew}>
                            Add New
                        </Button>
                    </Box>

                    <Box sx={{ marginRight: { xs: '10px', sm: '20px' }, maxWidth: '300px', flex: '1' }}>
                        <Input
                            placeholder="Search by product or variant"
                            size="md"
                            // value={searchText}
                            // onChange={handleSearch}
                            style={{ width: '100%' }}
                        />
                    </Box>
                </Box>
            </Box>

            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '15px', marginBottom: { xs: '15px', sm: '0px' } }}>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '1200px',
                        bgcolor: '#ffff',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '5px',
                        margin: '0 10px',
                        '& .ant-table-body': {
                            scrollbarWidth: 'thin',
                            scrollbarColor: '#888 #f1f1f1',

                            '&::-webkit-scrollbar': {
                                width: '6px',
                                height: '6px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#888',
                                borderRadius: '3px',
                            },
                            '&::-webkit-scrollbar-track': {
                                backgroundColor: '#f1f1f1',
                            },
                        },
                        '& .ant-pagination': {
                            paddingRight: '20px',
                        },

                    }}
                >

                    <ProductTable />

                </Box>
            </Box>
        </Box>
    );
}

export default ProductPage;
